import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { Erro404Component } from './pages/erro/404/erro-404.component';
import { EsqueceuSenhaComponent } from './pages/esqueceu-senha/esqueceu-senha.component';
import { RetornoEmailComponent } from './pages/retorno-email/retorno-email.component';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import {
  LocalizeRouterModule, LocalizeParser, LocalizeRouterSettings, ManualParserLoader
} from '@gilsdav/ngx-translate-router';
import { Erro500Component } from './pages/erro/500/erro-500.component';
import { CadastroComponent } from './pages/cadastro/cadastro.component';
import { LandingHomeOfficeComponent } from './pages/landing/home-office/landing-home-office.component';
import { PoliticaPrivacidadeComponent } from './pages/politica-privacidade/politica-privacidade.component';
import { TermosUsoComponent } from './pages/termos-uso/termos-uso.component';
import { TesteJornadasDigitaisComponent } from './pages/demonstracao/teste-jornadas-digitais/teste-jornadas-digitais.component';
import { TesteCanaisContatoComponent } from './pages/demonstracao/teste-canais-contato/teste-canais-contato.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LandingContatoComponent } from './pages/landing/contato/landing-contato.component';
import { ApresentacaoComponent } from './pages/apresentacao/apresentacao.component';
import { TesteAssinaturaEletronicaComponent } from './pages/demonstracao/teste-assinatura-eletronica/teste-assinatura-eletronica.component';

export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '/assets/locales/', '.json');
}

// tslint:disable-next-line: max-line-length
export function createLocalizeLoader(translate: TranslateService, location: Location, settings: LocalizeRouterSettings) {
  return new ManualParserLoader(translate, location, settings, ['es', 'en', 'pt'], 'ROUTES.');
}

export const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/principal/principal.module').then(mod => mod.PrincipalModule)
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'recuperar-senha',
    component: EsqueceuSenhaComponent
  },
  {
    path: 'cadastro',
    component: CadastroComponent
  },  
  {
    path: 'RetornoEmailAction.do',
    component: RetornoEmailComponent,
    data: { skipRouteLocalization: true }
  },
  {
    path: '500',
    component: Erro500Component
  },
  {
    path: '404',
    component: Erro404Component
  },
  {
    path: 'landing-home-office',
    component: LandingHomeOfficeComponent
  },
  {
    path: 'landing-contato',
    component: LandingContatoComponent
  },
  {
    path: 'politica-privacidade',
    component: PoliticaPrivacidadeComponent
  },
  {
    path: 'termos-uso',
    component: TermosUsoComponent
  },
  {
    path: 'teste-jornadas-digitais',
    component: TesteJornadasDigitaisComponent
  },
  {
    path: 'teste-canais-contato',
    component: TesteCanaisContatoComponent
  },
  {
    path: 'teste-assinatura-eletronica',
    component: TesteAssinaturaEletronicaComponent
  },
  {
    path: 'apresentacao',
    component: ApresentacaoComponent
  }, 
  {
    path: '**',
    redirectTo: '/404',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    LocalizeRouterModule.forRoot(appRoutes, {
      parser: {
        provide: LocalizeParser,
        useFactory: createLocalizeLoader,
        deps: [TranslateService, Location, LocalizeRouterSettings]
      }
    })
  ],
  exports: [
    RouterModule,
    TranslateModule,
    LocalizeRouterModule
  ]
})

export class AppRoutingModule { }
